import React from 'react';
import {connect} from 'react-redux';
import Reports, {DisplayMode} from '../../components/report/Reports/Reports';
import {setOxMode, setOxListMode} from "../../store/ui/actions";

export class ReportsListPage extends React.Component {

    componentWillMount() {
        this.props.setOxMode(DisplayMode.MODE_LIST);
    }

    render() {
        return <Reports
            mode={DisplayMode.MODE_LIST}
            match={this.props.match}
            setOxListMode={this.props.setOxListMode}
            listMode={this.props.listMode}
        />
    }
}

function mapStateToProps(state, ownProps) {
    return {
        listMode: state.ui.oxListMode
    }
}

export default connect(mapStateToProps, {
    setOxMode, setOxListMode
})(ReportsListPage);



// WEBPACK FOOTER //
// src/containers/reports/ReportsListPage.js